import React from "react";
import { company, navLinks, services } from "../mock";

const Footer = () => {
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050a1a] text-white pt-20 pb-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex flex-col items-start gap-2">
              <img
                src={company.logoMark}
                alt=""
                aria-hidden="true"
                className="h-16 w-auto object-contain"
              />
              <div>
                <p className="font-['Playfair_Display'] text-xl whitespace-nowrap">{company.shortName}</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-white/50">
                  Business Consultants
                </p>
              </div>
            </div>
            <p className="mt-8 text-white/60 text-sm leading-relaxed font-['Outfit'] max-w-sm">
              {company.description}
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#CFA660] mb-5">
              Navigate
            </p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-white/80 hover:text-[#CFA660] text-sm font-['Outfit'] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#CFA660] mb-5">
              Practice
            </p>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollTo("services")}
                    className="text-white/80 hover:text-[#CFA660] text-sm font-['Outfit'] text-left transition-colors"
                  >
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#CFA660] mb-5">
              Contact
            </p>
            <ul className="space-y-3 text-sm font-['Outfit']">
              <li className="text-white/80">{company.phone}</li>
              <li>
                <a
                  href={`mailto:${company.email}`}
                  className="text-white/80 hover:text-[#CFA660] transition-colors"
                >
                  {company.email}
                </a>
              </li>
              <li className="text-white/60 text-xs leading-relaxed pt-2">
                {company.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 space-y-4">
          <p className="text-white/60 text-xs leading-relaxed font-['Outfit'] max-w-4xl">
            Securities offered through <strong className="text-white/80 font-semibold">FNEX Capital, LLC</strong>, Member{" "}
            <a
              href="https://www.finra.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#CFA660] hover:underline"
            >
              FINRA
            </a>{" "}
            &{" "}
            <a
              href="https://www.sipc.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#CFA660] hover:underline"
            >
              SIPC
            </a>
            . FNEX and Rampart Partners are not affiliated.{" "}
            <a
              href="https://www.fnexcapital.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-fnex-crs"
              className="text-[#CFA660] hover:underline"
            >
              FNEX Capital – Client Relationship Summary
            </a>
            .
          </p>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-2">
            <p className="text-white/40 text-xs font-['Outfit']">
              © {year} {company.name}. All rights reserved.
            </p>
            <p className="text-white/40 text-[10px] uppercase tracking-[0.3em] font-['Outfit']">
              Independent
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
